import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10.4453, r: 9.25, fill: "currentColor", stroke: "white", strokeWidth: 0.5 }));
export default SvgCircle;
